"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

var getFromStorage = function getFromStorage(key) {
  try {
    return JSON.parse(window.sessionStorage[key]);
  } catch (_error) {
    return null;
  }
};

var setToStorage = function setToStorage(key, value) {
  try {
    window.sessionStorage[key] = JSON.stringify(value);
  } catch (_error) {}
};

var useSession = typeof window === 'undefined' ? function (_, initial) {
  return [initial, function () {}];
} : function (key, initial) {
  var _useState = (0, _react.useState)(function () {
    return function (current) {
      return current == null ? (setToStorage(key, initial), initial) : current;
    }(getFromStorage(key));
  }),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  (0, _react.useEffect)(function () {
    setToStorage(key, value);
  });
  return [value, setValue];
};
var _default = useSession;
exports.default = _default;